import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { getNearFacilities } from '../../services/facility.service';

import { Facility } from '../../types/Facility';
import { isEqual } from 'lodash';

interface FacilityState {
  facilities?: Facility[] | null;
  isFacilityLoading: boolean;
}

const initialState: FacilityState = {
  facilities: null,
  isFacilityLoading: false,
};

export const fetchNearFacility = createAsyncThunk('readers/getNearFacilities', async (param: any) => await getNearFacilities(param));

export const facilitySlice = createSlice({
  name: 'facility',
  initialState,
  reducers: {
    updateNearFacilitieState: (state, action: PayloadAction<Facility[] | null>) => {
      if (action.payload && action.payload?.length > 0) {
        if (!isEqual(state.facilities, action.payload)) {
          state.facilities = action.payload || [];
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNearFacility.pending, (state) => {
        state.isFacilityLoading = true;
      })
      .addCase(fetchNearFacility.fulfilled, (state, action: PayloadAction<any>) => {
        if (action.payload.data) {
          state.facilities = action.payload.data.results;
        }
        state.isFacilityLoading = false;
      });
  },
});

export const { updateNearFacilitieState } = facilitySlice.actions;
export default facilitySlice.reducer;
